// extracted by mini-css-extract-plugin
module.exports = {"image":"banner_image__0__Ig","wrapper":"banner_wrapper___8H1F"};